import React from "react";

const TONES = {
  hero: [
    { c: "rgba(47,47,228,0.22)", x: "76%", y: "14%", s: "40vw", d: "0s" },
    { c: "rgba(22,46,147,0.18)", x: "18%", y: "88%", s: "34vw", d: "-7s" },
    { c: "rgba(91,91,255,0.14)", x: "96%", y: "72%", s: "30vw", d: "-14s" },
  ],
  soft: [
    { c: "rgba(47,47,228,0.14)", x: "88%", y: "18%", s: "30vw", d: "0s" },
    { c: "rgba(26,25,83,0.12)", x: "6%", y: "82%", s: "26vw", d: "-9s" },
  ],
};

/**
 * Soft animated mesh backdrop. Purely decorative: absolutely positioned,
 * pointer-events-none, and held still under prefers-reduced-motion.
 */
const Aurora = ({ tone = "soft", className = "" }) => (
  <div
    aria-hidden="true"
    className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
  >
    {(TONES[tone] || TONES.soft).map((b, i) => (
      <span
        key={i}
        className="aurora-blob"
        style={{
          background: `radial-gradient(circle, ${b.c} 0%, transparent 68%)`,
          left: b.x,
          top: b.y,
          width: b.s,
          height: b.s,
          animationDelay: b.d,
        }}
      />
    ))}
  </div>
);

export default Aurora;
